import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { apis, apiHolder, apiHolder as api, } from 'api';
import { FLOLDER, FolderId2NameMap } from '@web-mail/common/constant';
import SpamAlertIcon from '@/images/icons/alert/spam-alert-icon.svg';
import WarnYellow from '@web-common/components/UI/Icons/svgs/WarnYellow';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import Sticky from '../Sticky';
import OpenRecords from '../OpenRecords/OpenRecords';
import TranslateTips from '../TranslateTips';
import ScheduleDate from './component/ScheduleDate';
import { useAppSelector, useAppDispatch, MailActions, useActions } from '@web-common/state/createStore';
import { SenderPriority } from '../SenderPriority/sender_priority';
import TodoMailTip from '../TodoMail/TodoMailTip';
import ThumbUp from '../ThumbUp';
import get from 'lodash/get';
import RevokeTip from './RevokeTip';
import { Collapse } from 'antd';
import { ReactComponent as TranslateSuccess } from '@/images/translate_success.svg';
import { ReactComponent as ArrowExpandGray } from '@/images/icons/arrow_expand_gray.svg';
import { ReactComponent as ArrowDown } from '@/images/icons/arrow-down.svg';
import { ReactComponent as SimpCloseIcon } from '@/images/icons/close_simp.svg';
import { ReactComponent as WarnIcon } from '@/images/icons/warn.svg';
import moment from 'moment';
import RequestReadReceipt from '../RequestReadReceipt/RequestReadReceipt';
import variables from '@web-common/styles/export.module.scss';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import useGetUniqueFn from '@web-mail/hooks/useGetUniqueFn';
import { getIn18Text } from 'api';
import Unlock from '../Unlock/Unlock';
import { useContactModel } from '@web-common/hooks/useContactModel';
import EdmReplyFeedback from './EdmReplyFeedback';
import MailContentHeader from './component/MailContentHeader/MailContentHeader';
import MailDeliveryHistory from '@web-mail/components/MailDeliveryHistory';
import WmMailDeliveryHistory from '@web-mail/components/WmMailDeliveryHistory';
import useLocalStorage from '@/hooks/useLocalStorage';
import ApproveStatus from '@web-mail/components/ApproveStatus/ApproveStatus';
import Approve from '@web-mail/components/Approve/Approve';
const { Panel } = Collapse;
const SUSPICIOUS_MAP = new Map([
    ['hitMailboxWhite', '邮箱地址白名单'],
    ['hitMailboxWhiteTrack', '可疑-个人白名单漏入'],
    ['hitDomainWhite', '域白名单'],
    ['hitDomainWhiteTrack', '可疑-企业白名单漏入'],
    ['hitUserRuleTrack', '可疑-来信分类漏入'],
    ['hitUserRule', '来信分类规则'],
]);
const mockDeliveryData = {
    distributeCount: 0,
    distributeList: [],
};
const nsSettingPrefix = 'notShowSpamTipsForMail-';
const mailManagerApi = apiHolder.api.requireLogicalApi('mailConfApiImpl');
const storeApi = api.api.getDataStoreApi();
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const eventApi = apiHolder.api.getEventApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const productAuthApi = api.api.requireLogicalApi(apis.productAuthApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailPlusCustomerApi = apiHolder.api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const systemApi = api.api.getSystemApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const aiAssistantApi = api.api.requireLogicalApi(apis.aiAssistant);
const defalutIncludeTips = {
    revoke: true,
    scheduleDate: true,
    edmReplyFeedback: true,
    prompt: true,
    status: true,
    approve: true,
    deliveryHistory: true,
    wmDeliveryHistory: true,
    openRecord: true,
    thumbUp: true,
    delivery: true,
    translate: true,
    todo: true,
    requestReadReceip: true,
    head: true,
    unlock: true,
    spam: true,
    spamLeakage: true,
    phishing: true,
    spfWarn: true,
};
const ContentTips = ({ content, forceUpdate, listData, rclData, readOnlyData, openRecordData, getMailReadDetail, refreshData, emoticonInfo, handleEmoticon, translateInfo, handleTranslateLang, featureConfig, unlockMail, style, showMailHead, onShowMailHeadChange, includeTips = defalutIncludeTips, approvalFlow, fetchApprovalFlow, checkApproval, }) => {
    var _a, _b, _c, _d, _e;
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const { sendingMails } = useAppSelector(state => state.mailReducer);
    const reducer = useActions(MailActions);
    const translateEbRef = useRef(null);
    const tabList = useAppSelector(state => state.mailTabReducer.tabList);
    const tabUnClose = useMemo(() => {
        return !!tabList.find(item => (item === null || item === void 0 ? void 0 : item.id) === (content === null || content === void 0 ? void 0 : content.id));
    }, [tabList, content === null || content === void 0 ? void 0 : content.id]);
    const [riskReminderOpen, setRiskReminderOpen] = useState(false);
    const [deliveryData, setDeliveryData] = useState(mockDeliveryData);
    const [deliveryDetailKey, setDeliveryDetailKey] = useState('');
    const [deliveryDetailActiveKey, setDeliveryDetailActiveKey] = useState([]);
    const [aiAssistantReadMailTip, setAiAssistantReadMailTip] = useLocalStorage('ai_assistant_read_mail_tip', false);
    const aiAssistSideBarVisiable = useAppSelector(state => state.mailReducer.aiAssistSideBarVisiable);
    const dispatch = useAppDispatch();
    const [neverShow, setNeverShow] = useState(false);
    const [spam, setSpam] = useState(false);
    const [refuselist, setRefuselist] = useState([]);
    const folder = useMemo(() => {
        var _a;
        return (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder;
    }, [content]);
    const [showPhishing, setShowPhishing] = useState(false);
    const [showSuspicious, setShowSuspicious] = useState(false);
    const [spfWarnVisible, setSpfWarnVisible] = useState(false);
    const isPhishing = useMemo(() => {
        var _a;
        return content.entry.suspiciousSpam === true && ((_a = content.antispamInfo) === null || _a === void 0 ? void 0 : _a.asMailType) === 'phishing';
    }, [content]);
    const isDubious = useMemo(() => {
        var _a, _b;
        return content.entry.suspiciousSpam === true && ((_a = content.antispamInfo) === null || _a === void 0 ? void 0 : _a.asMailType) != null && ((_b = content.antispamInfo) === null || _b === void 0 ? void 0 : _b.asMailType) !== 'phishing';
    }, [content]);
    const suspiciousIgnoreReason = useMemo(() => {
        var _a;
        return ((_a = content.antispamInfo) === null || _a === void 0 ? void 0 : _a.asIgnoreReason) || '';
    }, [content]);
    useEffect(() => {
        if ((isPhishing || isDubious) && suspiciousIgnoreReason && folder !== 5 && !showSuspicious) {
            setShowSuspicious(true);
            setTrackData();
        }
        else if ((isPhishing || isDubious) && !showPhishing && !showSuspicious) {
            setShowPhishing(true);
        }
    }, [isPhishing, isDubious, suspiciousIgnoreReason, tabUnClose]);
    useEffect(() => {
        var _a;
        setSpfWarnVisible(Boolean((_a = content.originalTags) === null || _a === void 0 ? void 0 : _a.includes('%st_sys_spf_warn%')));
    }, [content]);
    const { productVersionInfo: { productVersionId, navigateVersion }, } = useGetProductAuth();
    const senderContactModel = useContactModel({
        email: ((_c = (_b = (_a = content === null || content === void 0 ? void 0 : content.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName) || '',
    });
    const promptShow = useMemo(() => {
        var _a, _b, _c, _d, _e;
        const isSpam = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.suspiciousSpam;
        const isSenderInContactBook = (senderContactModel === null || senderContactModel === void 0 ? void 0 : senderContactModel.contact.type) && (senderContactModel === null || senderContactModel === void 0 ? void 0 : senderContactModel.contact.type) !== 'external';
        const isSystem = (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.system;
        const inSpecbox = [1, 5, 4].includes(folder) || folder >= 100;
        const senderEmail = ((_e = (_d = (_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.accountName) || '';
        return ((content === null || content === void 0 ? void 0 : content.entry) &&
            !isSenderInContactBook &&
            inSpecbox &&
            !isSystem &&
            !isSpam &&
            !isCorpMail &&
            ['sirius'].includes(productVersionId) &&
            !accountApi.doGetEmailInCurrentDomain(senderEmail) &&
            !refuselist.includes(senderEmail));
    }, [content, folder, isCorpMail, productVersionId, refuselist, senderContactModel === null || senderContactModel === void 0 ? void 0 : senderContactModel.contact.type]);
    const getRefuselist = useCallback(() => {
        storeApi.get('refuselist', { _account: content === null || content === void 0 ? void 0 : content._account }).then((res) => {
            const { suc, data } = res;
            if (!suc || !data)
                return;
            try {
                const refuselist = JSON.parse(data);
                if (Array.isArray(refuselist)) {
                    setRefuselist(refuselist);
                }
            }
            catch (error) {
                console.log('获取黑名单失败', error);
            }
        });
    }, []);
    const handleDoGetContactByEmailsAdvance = useGetUniqueFn((mapRes, res, result) => {
        res.distributeList.forEach(i => {
            i.distributeMember.forEach(c => {
                var _a, _b;
                c.contactName = ((_b = (_a = mapRes[c.email][0]) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contactName) || '';
            });
        });
        const distributeListCp = res.distributeList.sort((a, b) => +b.distributeTime - +a.distributeTime);
        result.distributeList = distributeListCp;
        return result;
    }, [content === null || content === void 0 ? void 0 : content.id]);
    const transformData = (res) => {
        let result = {
            distributeCount: res.distributeCount,
            distributeList: res.distributeList,
        };
        const emailArr = [];
        res.distributeList.forEach(i => {
            i.distributeMember.forEach(c => {
                emailArr.push(c.email);
            });
        });
        return contactApi
            .doGetContactByEmailsAdvance({
            emails: [...new Set(emailArr)],
            useEdm: systemApi.inEdm(),
            needGroup: true,
        })
            .then(({ mapRes }) => {
            return handleDoGetContactByEmailsAdvance(mapRes, res, result);
        });
    };
    const handleMailDeliveryDetailChange = useGetUniqueFn(async (res) => {
        if (res && res.distributeCount) {
            const result = await transformData(res);
            setDeliveryData(result);
        }
        else {
            setDeliveryData({
                distributeCount: 0,
                distributeList: [],
            });
        }
    }, [content === null || content === void 0 ? void 0 : content.id]);
    const handleMailDeliveryDetailError = useGetUniqueFn(err => {
        setDeliveryData({
            distributeCount: 0,
            distributeList: [],
        });
        console.log('获取邮件分发详情失败:', err);
    }, [content === null || content === void 0 ? void 0 : content.id]);
    const getDeliveryDetail = (mid) => {
        var _a, _b;
        if ((_a = content.entry) === null || _a === void 0 ? void 0 : _a.directForwarded) {
            setDeliveryDetailActiveKey(['0']);
            (_b = document.getElementsByClassName('delivery-tip-content')[0]) === null || _b === void 0 ? void 0 : _b.scrollTo({ top: 0 });
            mailApi
                .getMailDeliveryDetail(mid, content._account || '')
                .then(async (res) => {
                handleMailDeliveryDetailChange(res);
            })
                .catch(err => {
                handleMailDeliveryDetailError(err);
            });
        }
        else {
            setDeliveryData({
                distributeCount: 0,
                distributeList: [],
            });
        }
    };
    useEffect(() => {
        getDeliveryDetail(content === null || content === void 0 ? void 0 : content.id);
    }, [content === null || content === void 0 ? void 0 : content.id, (_d = content.entry) === null || _d === void 0 ? void 0 : _d.directForwarded]);
    const riskReminderStatusChange = useGetUniqueFn(res => {
        setRiskReminderOpen([0, 2].includes(res));
    }, [content === null || content === void 0 ? void 0 : content.id]);
    useEffect(() => {
        if ((process.env.BUILD_ISEDM || navigateVersion) && content && content.id && !content.isTpMail) {
            if (content.entry.folder && content.entry.folder !== FLOLDER.DELETED && content.entry.folder !== FLOLDER.DRAFT) {
                mailPlusCustomerApi.doGetMailStatusOfFollow(content.id, content._account).then(res => {
                    const { mid, processed } = res;
                    if (mid) {
                        const isFollowUp = processed;
                        reducer.doUpdateFollowStatus({
                            mailId: mid,
                            isFollowUp,
                        });
                    }
                });
            }
        }
    }, [content === null || content === void 0 ? void 0 : content.id, navigateVersion]);
    useEffect(() => {
        if (isCorpMail)
            return;
        mailManagerApi.getRiskReminderStatus(undefined, content === null || content === void 0 ? void 0 : content._account).then((res) => {
            riskReminderStatusChange(res);
        });
        getRefuselist();
    }, [content === null || content === void 0 ? void 0 : content.id, riskReminderStatusChange]);
    useEffect(() => {
        if (content && content.id) {
            storeApi.get(nsSettingPrefix + content.id, { _account: content === null || content === void 0 ? void 0 : content._account }).then(rs => {
                setNeverShow(!!rs && rs.suc && !!rs.data && rs.data === 'true');
            });
        }
    }, [content === null || content === void 0 ? void 0 : content.id]);
    useEffect(() => {
        translateEbRef.current && translateEbRef.current.reset();
    }, [content === null || content === void 0 ? void 0 : content.id]);
    const RevokeElement = useMemo(() => {
        const sendingMail = sendingMails.find(item => item.id === (content === null || content === void 0 ? void 0 : content.id));
        if (sendingMail) {
            return React.createElement(RevokeTip, { sendingMail: sendingMail });
        }
        return React.createElement(React.Fragment, null);
    }, [sendingMails.length, content === null || content === void 0 ? void 0 : content.id]);
    const ScheduleDateElement = useMemo(() => {
        return React.createElement(ScheduleDate, { content: content });
    }, [content]);
    const promptShowElement = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const senderEmail = ((_c = (_b = (_a = content === null || content === void 0 ? void 0 : content.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.accountName) || '';
        const senderName = ((_f = (_e = (_d = content === null || content === void 0 ? void 0 : content.sender) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.contactName) || '';
        return (React.createElement("div", { style: { padding: ' 0 16px' } },
            React.createElement(SenderPriority, { defaultPriority: (_j = (_h = (_g = content === null || content === void 0 ? void 0 : content.sender) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.priority, key: (_k = content === null || content === void 0 ? void 0 : content.entry) === null || _k === void 0 ? void 0 : _k.id, riskMinderOpen: riskReminderOpen, _account: content === null || content === void 0 ? void 0 : content._account, contactId: '', email: senderEmail, contact: (_l = content === null || content === void 0 ? void 0 : content.sender) === null || _l === void 0 ? void 0 : _l.contact, sender: {
                    email: senderEmail,
                    name: senderName,
                    type: (_p = (_o = (_m = content === null || content === void 0 ? void 0 : content.sender) === null || _m === void 0 ? void 0 : _m.contact) === null || _o === void 0 ? void 0 : _o.contact) === null || _p === void 0 ? void 0 : _p.type,
                } })));
    }, [content, riskReminderOpen]);
    const closeAiAssistantTip = () => {
        setAiAssistantReadMailTip(true);
    };
    const openAiAssistant = () => {
        aiAssistantApi.sendNotification({ type: 'tipOpen', data: true });
        dispatch(MailActions.doUpdateAiAssistVisiable(true));
        setAiAssistantReadMailTip(true);
    };
    const AiAssistantReadMailTipComp = useMemo(() => {
        return !aiAssistantReadMailTip && !aiAssistSideBarVisiable ? (React.createElement("div", { className: "u-ai-assistant-alert-read-mail" },
            React.createElement("span", { className: "icon" }),
            React.createElement("span", { className: "txt" }, getIn18Text('YOUJIANNEIRONGGUOCHANG')),
            React.createElement("span", { className: "btn", onClick: openAiAssistant }, getIn18Text('LIJIZONGJIE')),
            React.createElement("span", { className: "close", onClick: closeAiAssistantTip }))) : null;
    }, [aiAssistantReadMailTip, aiAssistSideBarVisiable]);
    const MailStatusElement = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const accountAlias = ((_b = (_a = systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
        const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
        const senderEmail = ((_e = (_d = (_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.accountName) || '';
        let forbid = false;
        try {
            const forbidList = JSON.parse(productAuthApi.getABSwitchSync('mail_trace_forbidden_domains'));
            if (forbidList && forbidList.length) {
                const userInfo = systemApi.getCurrentUser();
                if (forbidList.find((item) => { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) === null || _a === void 0 ? void 0 : _a.endsWith(item); })) {
                    forbid = true;
                }
            }
        }
        catch (e) {
        }
        const isSend = ((_f = content === null || content === void 0 ? void 0 : content.entry) === null || _f === void 0 ? void 0 : _f.folder) === FLOLDER.SENT ||
            accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) ||
            accountApi.getIsSameSubAccountSync(senderEmail, content._account);
        if (isSend &&
            listData &&
            !isCorpMail &&
            (!content.authAccountType || content.authAccountType === '0')) {
            return (React.createElement(Sticky, { mid: (_g = content === null || content === void 0 ? void 0 : content.entry) === null || _g === void 0 ? void 0 : _g.id, tid: (_h = content === null || content === void 0 ? void 0 : content.entry) === null || _h === void 0 ? void 0 : _h.tid, fid: (_j = content === null || content === void 0 ? void 0 : content.entry) === null || _j === void 0 ? void 0 : _j.folder, rclData: rclData, readData: readOnlyData, refreshData: refreshData, content: content, forbid: forbid }));
        }
        return React.createElement(React.Fragment, null);
    }, [content, listData, rclData, readOnlyData, refreshData, isCorpMail, featureConfig]);
    const MailApproveElement = useMemo(() => {
        if (!approvalFlow)
            return React.createElement(React.Fragment, null);
        const { waitByMe, createByMe } = approvalFlow;
        if (waitByMe) {
            return React.createElement(Approve, { recordFlow: approvalFlow, fetchApprovalFlow: fetchApprovalFlow, checkApproval: checkApproval });
        }
        if (createByMe) {
            return React.createElement(ApproveStatus, { recordFlow: approvalFlow, fetchApprovalFlow: fetchApprovalFlow, checkApproval: checkApproval });
        }
        return React.createElement(React.Fragment, null);
    }, [approvalFlow]);
    const MailDeliveryHistoryElement = useMemo(() => {
        var _a, _b, _c, _d, _e;
        if (!process.env.BUILD_ISED && (((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.forwarded) || ((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.replayed))) {
            return React.createElement(MailDeliveryHistory, { mid: (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.id, content: content, forwarded: (_d = content === null || content === void 0 ? void 0 : content.entry) === null || _d === void 0 ? void 0 : _d.forwarded, replyed: (_e = content === null || content === void 0 ? void 0 : content.entry) === null || _e === void 0 ? void 0 : _e.replayed });
        }
        return React.createElement(React.Fragment, null);
    }, [content]);
    const WmMailDeliveryHistoryElement = useMemo(() => {
        var _a, _b, _c;
        if (process.env.BUILD_ISEDM || navigateVersion) {
            return React.createElement(WmMailDeliveryHistory, { mid: (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id, content: content, forwarded: (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.forwarded, replyed: (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.replayed });
        }
        return React.createElement(React.Fragment, null);
    }, [content]);
    const OpenRecordsElement = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        const versionId = productAuthApi.doGetProductVersionId();
        const accountAlias = ((_b = (_a = systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
        const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
        const senderEmail = ((_e = (_d = (_c = content === null || content === void 0 ? void 0 : content.sender) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.accountName) || '';
        let forbid = false;
        try {
            const forbidList = JSON.parse(productAuthApi.getABSwitchSync('mail_trace_forbidden_domains'));
            if (forbidList && forbidList.length) {
                const userInfo = systemApi.getCurrentUser();
                if (forbidList.find((item) => { var _a; return (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) === null || _a === void 0 ? void 0 : _a.endsWith(item); })) {
                    forbid = true;
                }
            }
        }
        catch (e) {
        }
        const isSend = ((_f = content === null || content === void 0 ? void 0 : content.entry) === null || _f === void 0 ? void 0 : _f.folder) === FLOLDER.SENT ||
            accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) ||
            accountApi.getIsSameSubAccountSync(senderEmail, content._account);
        if (versionId === 'sirius' && isSend && content.authAccountType && content.authAccountType !== '0') {
            return React.createElement(OpenRecords, { content: content, openRecordData: openRecordData, getMailReadDetail: getMailReadDetail, forbid: forbid });
        }
        return React.createElement(React.Fragment, null);
    }, [content, openRecordData, featureConfig]);
    const UnlockElement = useMemo(() => {
        const { isEncryptedMail } = content;
        if (isEncryptedMail)
            return React.createElement(Unlock, { content: content, unlockMail: unlockMail });
        return React.createElement(React.Fragment, null);
    }, [content]);
    const ThumbUpElement = useMemo(() => {
        if (!isCorpMail && emoticonInfo && emoticonInfo.involvedRecords && (emoticonInfo === null || emoticonInfo === void 0 ? void 0 : emoticonInfo.involvedRecords.length) > 0) {
            return React.createElement(ThumbUp, { mid: content.entry.id, content: content, emoticonInfo: emoticonInfo, handleEmoticon: handleEmoticon });
        }
        return React.createElement(React.Fragment, null);
    }, [isCorpMail, emoticonInfo, content, handleEmoticon]);
    const closeAndNeverShow = useCallback(() => {
        setNeverShow(true);
        storeApi.put(nsSettingPrefix + (content === null || content === void 0 ? void 0 : content.id), 'true');
    }, [content]);
    const SpamElement = useMemo(() => {
        if (!neverShow && spam) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "spam-alert-style" },
                    React.createElement("span", null, getIn18Text('GAIYOUJIANKENENG')),
                    React.createElement("a", { onClick: () => {
                            const senderEmail = get(content, ['sender', 'contactItem', 'contactItemVal'], '');
                            eventApi.sendSysEvent({
                                eventName: 'mailMenuOper',
                                eventData: {
                                    mailId: content.entry.id,
                                    hasReport: false,
                                    senderEmail,
                                },
                                eventStrData: 'report',
                                _account: content._account,
                            });
                        } }, "\u53BB\u4E3E\u62A5"),
                    React.createElement("span", { className: "spam-alert-warn" },
                        React.createElement(WarnIcon, null)),
                    React.createElement("span", { className: "spam-alert-style-close", onClick: closeAndNeverShow },
                        React.createElement(SimpCloseIcon, null)))));
        }
        return React.createElement(React.Fragment, null);
    }, [neverShow, spam, closeAndNeverShow]);
    const handleDeliveryTipShow = useCallback(() => {
        if (deliveryDetailKey) {
            setDeliveryDetailKey('');
        }
        else {
            setDeliveryDetailKey('0');
        }
    }, [deliveryDetailKey]);
    const handleDeliveryChange = useCallback((key) => {
        setDeliveryDetailActiveKey(key);
    }, []);
    const DeliveryTipElement = useMemo(() => {
        if (deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.distributeCount) {
            const header = (React.createElement(React.Fragment, null,
                React.createElement(TranslateSuccess, null),
                React.createElement("span", { className: "delivery-tip-title" },
                    "\u90AE\u4EF6\u5DF2\u7ECF\u5206\u53D1",
                    deliveryData.distributeCount,
                    "\u6B21"),
                React.createElement("span", { className: "delivery-tip-btn", onClick: handleDeliveryTipShow }, deliveryDetailKey ? getIn18Text('SHOUQI') : getIn18Text('XIANGQING'))));
            return (React.createElement(Collapse, { activeKey: deliveryDetailKey, bordered: false, className: "delivery-outer" },
                React.createElement(Panel, { showArrow: false, header: header, key: "0", className: "delivery-tip-header" },
                    React.createElement(Collapse, { bordered: false, onChange: handleDeliveryChange, activeKey: deliveryDetailActiveKey, expandIcon: ({ isActive }) => (isActive ? React.createElement(ArrowDown, { width: 8, height: 8 }) : React.createElement(ArrowExpandGray, { width: 8, height: 8 })), className: "delivery-tip-content", ghost: true }, deliveryData.distributeList &&
                        deliveryData.distributeList.map((data, index) => {
                            return (React.createElement(Panel, { header: React.createElement("span", { className: "delivery-tip-time" }, moment(data.distributeTime).format('YYYY-MM-DD HH:mm')), key: index, style: { border: 'none', margin: 0, backgroundColor: 'transparent' } },
                                React.createElement("div", { className: "delivery-tip-email" }, data.distributeMember.map((i, idx) => {
                                    if (i.contactName) {
                                        return (React.createElement("span", { key: idx },
                                            `${idx === 0 ? '' : '、'}${i.contactName} `,
                                            React.createElement("span", { style: { color: `${variables.text3}` } }, `(${i.email})`)));
                                    }
                                    else {
                                        return `${idx === 0 ? '' : '、'}${i.email}`;
                                    }
                                }))));
                        })))));
        }
        else {
            return null;
        }
    }, [deliveryData, deliveryDetailKey, handleDeliveryTipShow, handleDeliveryChange, deliveryDetailActiveKey]);
    const isThread = mailManagerApi.getMailMergeSettings() === 'true';
    const SpamLeakage = useMemo(() => {
        return (React.createElement("div", { className: `spam-leakage${isThread ? ' spam-leakage-mg' : ''}` },
            React.createElement("span", null,
                getIn18Text('GAIYOUJIANYISHIZHAPIAN'),
                SUSPICIOUS_MAP.get(suspiciousIgnoreReason),
                getIn18Text('LOURUCIWENJIANJIA。')),
            React.createElement("div", { className: "spam-leakage-btn" },
                React.createElement("a", { onClick: () => {
                        const result = new Map();
                        result.set(content === null || content === void 0 ? void 0 : content.id, { suspiciousSpam: false });
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: {
                                mailId: content === null || content === void 0 ? void 0 : content.id,
                                result,
                            },
                            eventStrData: 'completeTrust',
                            _account: content === null || content === void 0 ? void 0 : content._account,
                        });
                        setShowSuspicious(false);
                    } }, getIn18Text('XINRENYOUJIAN')),
                React.createElement("a", { onClick: () => {
                        const senderEmail = get(content, ['sender', 'contactItem', 'contactItemVal'], '');
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: {
                                mailId: content.entry.id,
                                hasReport: false,
                                senderEmail,
                            },
                            eventStrData: 'report',
                            _account: content._account,
                        });
                    } }, getIn18Text('JUBAOYOUJIAN'))),
            React.createElement("img", { className: "spam-leakage-warn", src: SpamAlertIcon, alt: "" }),
            React.createElement("span", { className: "spam-leakage-close", onClick: () => setShowSuspicious(false) },
                React.createElement(SimpCloseIcon, null))));
    }, [suspiciousIgnoreReason]);
    const PhishingMail = useMemo(() => {
        return (React.createElement("div", { className: "new-spam-alert-style" },
            React.createElement("div", { style: {
                    marginBottom: 4,
                } }, isPhishing ? getIn18Text('GAIYOUJIANKENENGWEIDIAO') : getIn18Text('GAIYOUJIANKENENG')),
            React.createElement("div", { style: {
                    marginLeft: '-20px',
                } },
                isPhishing && (React.createElement("a", { style: {
                        marginLeft: 20,
                    }, href: "/static_html/phishing_mail_intro.html", target: "_blank" }, getIn18Text('RUHESHIBIEDIAOYUYOU'))),
                React.createElement("a", { style: {
                        marginLeft: 20,
                    }, onClick: () => {
                        const senderEmail = get(content, ['sender', 'contactItem', 'contactItemVal'], '');
                        eventApi.sendSysEvent({
                            eventName: 'mailMenuOper',
                            eventData: {
                                mailId: content.entry.id,
                                hasReport: false,
                                senderEmail,
                            },
                            eventStrData: 'report',
                            _account: content._account,
                        });
                    } }, getIn18Text('QUJUBAO'))),
            React.createElement("img", { className: "spam-alert-warn", src: SpamAlertIcon, alt: "" }),
            React.createElement("span", { className: "spam-alert-style-close", onClick: () => setShowPhishing(false) },
                React.createElement(SimpCloseIcon, null))));
    }, [isPhishing]);
    const spfWarnElem = useMemo(() => {
        return (React.createElement("div", { className: "spam-alert-warn-style" },
            React.createElement("div", null, getIn18Text('CIYOUJIANDEFAXINDIZHI')),
            React.createElement(WarnYellow, { className: "spam-alert-warn" }),
            React.createElement("span", { className: "spam-alert-style-close", onClick: () => {
                    setSpfWarnVisible(false);
                } },
                React.createElement(SimpCloseIcon, null))));
    }, []);
    const TodoMailTipElement = useMemo(() => {
        return content.entry.isDefer ? (React.createElement(TodoMailTip, { content: content, isDefer: content.entry.isDefer, deferTime: content.entry.deferTime, deferNotice: content.entry.deferNotice })) : (React.createElement(React.Fragment, null));
    }, [content]);
    const TranslateTipElement = useMemo(() => {
        const showMailTranslate = !isCorpMail;
        return showMailTranslate && handleTranslateLang ? (React.createElement(ErrorBoundary, { ref: r => (translateEbRef.current = r), name: "ContentTip-TranslateTip", extraInfo: {
                translateInfo: translateInfo,
            }, errorVisiable: false },
            React.createElement(TranslateTips, { content: content, translateInfo: translateInfo || { status: 'none' }, handleTranslateLang: handleTranslateLang }))) : (React.createElement(React.Fragment, null));
    }, [isCorpMail, translateInfo, handleTranslateLang, content]);
    const RequestReadReceiptTipElement = useMemo(() => {
        var _a;
        const receiptDoneIds = storeApi.getSync('receiptDoneIds').data;
        const done = receiptDoneIds ? receiptDoneIds.includes(content === null || content === void 0 ? void 0 : content.id) : false;
        return (React.createElement(React.Fragment, null, content.entry.requestReadReceiptLocal &&
            !done &&
            ![2, 3].includes((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder) && React.createElement(RequestReadReceipt, { id: content === null || content === void 0 ? void 0 : content.id, account: content === null || content === void 0 ? void 0 : content._account })));
    }, [content.entry.requestReadReceiptLocal, content === null || content === void 0 ? void 0 : content.id]);
    const setTrackData = useCallback(() => {
        const folderName = FolderId2NameMap[folder + ''] || '自定义文件夹';
        if (showSuspicious) {
            trackApi.track('show_suspiciousMailRemind_mailDetailPage', {
                remindType: SUSPICIOUS_MAP.get(`${suspiciousIgnoreReason}Track`),
                folder: folderName,
            });
        }
        else if (showPhishing) {
            trackApi.track('show_suspiciousMailRemind_mailDetailPage', {
                remindType: isPhishing ? '钓鱼邮件' : '异常垃圾邮件',
                folder: folderName,
            });
        }
    }, [showSuspicious, showPhishing, isPhishing, suspiciousIgnoreReason, folder]);
    const MailHeadrElement = useMemo(() => {
        var _a;
        return React.createElement(MailContentHeader, { visiable: showMailHead, onVisiableChange: onShowMailHeadChange, mid: (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.id, account: content === null || content === void 0 ? void 0 : content._account });
    }, [showMailHead, onShowMailHeadChange, (_e = content === null || content === void 0 ? void 0 : content.entry) === null || _e === void 0 ? void 0 : _e.id]);
    if (isDubious || isPhishing) {
        return (React.createElement(React.Fragment, null,
            showSuspicious && includeTips.spamLeakage ? SpamLeakage : showPhishing && includeTips.phishing ? PhishingMail : null,
            includeTips.spfWarn && spfWarnVisible ? spfWarnElem : null));
    }
    return (React.createElement("div", { style: style },
        includeTips.spfWarn && spfWarnVisible ? spfWarnElem : null,
        includeTips.revoke && RevokeElement,
        includeTips.scheduleDate && ScheduleDateElement,
        includeTips.edmReplyFeedback && process.env.BUILD_ISEDM && React.createElement(EdmReplyFeedback, { content: content }),
        includeTips.prompt && promptShow && promptShowElement,
        includeTips.status && MailStatusElement,
        MailApproveElement,
        includeTips.deliveryHistory && MailDeliveryHistoryElement,
        includeTips.wmDeliveryHistory && WmMailDeliveryHistoryElement,
        includeTips.openRecord && OpenRecordsElement,
        includeTips.thumbUp && ThumbUpElement,
        includeTips.spam && SpamElement,
        includeTips.delivery && DeliveryTipElement,
        includeTips.translate && TranslateTipElement,
        includeTips.todo && TodoMailTipElement,
        includeTips.requestReadReceip && RequestReadReceiptTipElement,
        includeTips.head && MailHeadrElement,
        includeTips.unlock && UnlockElement));
};
export default ContentTips;
